const TaskActiveStatus = [
  { label: "Active", value: true },
  { label: "Deleted", value: false },
];

export default TaskActiveStatus;
